export default {
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    cancel: 'Cancel',

    'basic-data': 'Main Info.',
    'material-name': 'Item name',
    'main-material': 'Main item',
    'account-no-is-automatic-or-manual': 'Account ID (auto or manual)',
    
    'material-type': {
        title: 'Item type',
        main: 'Main',
        sub: 'Sub',
    },

    'material-category':{
        title: 'Item classification',
        'commercial-ordinary-material': 'Product',
        'raw-material': 'Raw material',
        'indirect-raw-material': 'Indirect raw material',
        'material-under-manufacture': 'Semi-manufactured material',
        'manufactured-material': 'Manufactured material',
    },

    'unit-size': 'Unit',
    'additional-data': 'Additional info.',

    'min': 'Min.',
    'max': 'Max.',
    manufacturer: 'Manufacturer',
    specifications: 'Specifications / Source',

    'material-movement-data': 'Trading Info.',
    
    'purchasing-price': 'Purchase price',
    'selling-price': 'Sale price',
    'purchase-account': 'Purchase account',
    'sales-account': 'Sales account',
    notes: 'Notes',
    
    'delete-the-material': 'Delete item',
    'are-you-sure-you-want-to-delete-the-material-$': 'Do you want to delete this item: {materialName}?',
    
    'edit-material': 'Edit item',
    'create-material': 'Create item',
    'interlocking-materials': 'Interlocking materials',
    'materials-that-have-the-same-barcode': 'Materials that have the same barcode',
    'confirm-disengagement-of-material': 'Confirm disengagement of material',
    'are-you-sure-you-want-to-disconnect?': 'Are you sure you want to disconnect?'
}